var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('header',{staticClass:"site-header"},[_c('BrandLogo'),_c('AccountMenu')],1),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }